import { AHRIDataParameter, getAHRISystemToolData } from "@crescentParts/Services/AHRISystemToolService";
import { AHRIDataModel } from "@crescentParts/Widgets/CustomApiModels";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

type Parameter = AHRIDataParameter & HasOnSuccess<AHRIDataModel>;

type Props = {
    apiParameter: Parameter;
    apiResult: AHRIDataModel;
};

type HandlerType = ApiHandlerDiscreteParameter<Parameter, Props, AHRIDataModel>


export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getAHRISystemToolData(props.parameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [SendDataToApi, ExecuteOnSuccessCallback];

const getAHRISystemToolHandlerData = createHandlerChainRunner(chain, "getAHRISystemToolHandlerData");
export default getAHRISystemToolHandlerData;
